import { Component, OnInit } from '@angular/core';
import { IconsService }      from '@omnilnp/services/icons.service';
import { RegisterService }   from '@omnilnp/services/register.service';
import { RouterService }     from '@omnilnp/services/router.service';

@Component({
  selector: 'lenerspas-dutchaddress',
  templateUrl: './dutchaddress.component.html',
})
export class DutchAddressComponent implements OnInit {

  addressloading: boolean = false;

  constructor ( public icons:    IconsService
              , public register: RegisterService
              , public router:   RouterService
              ) {}

  ngOnInit() {
    this.initialize();
  }

  initialize() {
    this.router.showwait = false;
  }

  orderasis(a: any, b: any) {
    return 1;
  }

  keyup( key, value ) {
    if ( key == 'zipcode' ) {
      if ( value.length == 4 ) {
        this.register.dutchaddress.zipcode.value = value+' ';
      } else {
        this.register.dutchaddress.zipcode.value = value.toUpperCase();
      }
      return;
    }
  }

  async checkinput( key, value ) {
    if ( ( key == 'zipcode' || key == 'housenumber' ) ) {
      if (     this.register.normalizePostcode( this.register.dutchaddress.zipcode.value ).length == 6
            && this.register.dutchaddress.housenumber.value.trim().length > 0
         ) {
        this.addressloading = true;
        let result = await this.register.searchAddress ( this.register.dutchaddress );
        // A stale result means a newer lookup owns the loading state, or a clear already ended it.
        if ( result != 'stale' ) {
          this.addressloading = false;
        }
      } else {
        this.register.clearAddress( this.register.dutchaddress );
        this.addressloading = false;
      }
      return;
    }

    if ( key == 'housenumber_suffix' ) {
      this.register.dutchaddress.fulladdress.value = this.register.buildFullAddress( this.register.dutchaddress );
      return;
    }
  }

  checkrequiredfields( bool = false ) {
    return this.addressloading || !this.register.hasValidAddress( this.register.dutchaddress );
  }

  async back() {
    await this.router.navigateto('register');
  }

  async submit() {
    this.router.navigateto('overview');
  }

}
